var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContactWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "337803DA-174C-47D0-BC7D-974501548CE0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-white",
    transform: "translate(-112.000000, -24.292893)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons/32/contact-white",
    transform: "translate(112.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,13 L9,18 L9.00548574,18.1492623 C9.08183488,19.1841222 9.9456382,20 11,20 L22,20 L22,24 C22,24.5128358 21.6139598,24.9355072 21.1166211,24.9932723 L21,25 L9,25 L5.85355339,28.1464466 C5.7597852,28.2402148 5.63260824,28.2928932 5.5,28.2928932 C5.22385763,28.2928932 5,28.0690356 5,27.7928932 L5,14 C5,13.4477153 5.44771525,13 6,13 L9,13 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    opacity: 0.64
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11,7 L26,7 C26.5522847,7 27,7.44771525 27,8 L27,21.7928932 C27,22.0690356 26.7761424,22.2928932 26.5,22.2928932 C26.3673918,22.2928932 26.2402148,22.2402148 26.1464466,22.1464466 L23,19 L23,19 L11,19 C10.4477153,19 10,18.5522847 10,18 L10,8 C10,7.44771525 10.4477153,7 11,7 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactWhite);
export default __webpack_public_path__ + "static/media/iconContactWhite.9c549a67bba6cf8db572128b5ecb0167.svg";
export { ForwardRef as ReactComponent };